 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }
import {getAscendingIdx, getDescendingIdx} from './addNodeToArray'

export const insertEdgeBefore = (
  connection,
  newEdge,
  propName
) => {
  const edges = connection.getLinkedRecords('edges')
  const newName = _optionalChain([newEdge, 'access', _ => _.getLinkedRecord, 'call', _2 => _2('node'), 'optionalAccess', _3 => _3.getValue, 'call', _4 => _4(propName)]) 
  const newEdgeIdx = edges.findIndex((edge) => {
    const edgeName = edge ? (_optionalChain([edge, 'access', _5 => _5.getLinkedRecord, 'call', _6 => _6('node'), 'optionalAccess', _7 => _7.getValue, 'call', _8 => _8(propName)]) ) : ''
    return edgeName > newName
  })
  const nextEdges =
    newEdgeIdx === -1
      ? edges.concat(newEdge)
      : [...edges.slice(0, newEdgeIdx), newEdge, ...edges.slice(newEdgeIdx)]
  connection.setLinkedRecords(nextEdges, 'edges')
}

export const insertNodeBefore = (nodes, newNode, propName) => {
  const newName = newNode.getValue(propName) 
  const newIdx = nodes.findIndex((node) => {
    const nodeName = node ? (node.getValue(propName) ) : ''
    return nodeName > newName ? 1 : -1
  })
  return newIdx === -1
    ? nodes.concat(newNode)
    : [...nodes.slice(0, newIdx), newNode, ...nodes.slice(newIdx)]
}

// will build when needed



export const insertEdgeAfter = (
  connection,
  newEdge,
  sortValue,
  options = {}
) => {
  const {isAscending} = options
  const edges = connection.getLinkedRecords('edges')
  const nodes = edges.map((edge) => edge.getLinkedRecord('node'))
  const idxFinder = isAscending ? getAscendingIdx : getDescendingIdx
  const newName = sortValue
    ? (newEdge.getLinkedRecord('node').getValue(sortValue) )
    : ''
  const nextIdx = sortValue
    ? idxFinder(newName, nodes, sortValue)
    : isAscending
    ? edges.length - 1
    : 0
  const nextEdges = [...edges.slice(0, nextIdx), newEdge, ...edges.slice(nextIdx)]
  connection.setLinkedRecords(nextEdges, 'edges')
}
